import React from 'react';
import Apiwe from '../media/clients/Apiwe.jpg'
import MrAndMsAble from '../media/clients/MrAndMsAble.jpg'
import '../styles/clients.css'
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..

const Portfolio = () => {
    return (
        <section id="clients" className="section-bg">
            <div className="container">
                <div className="section-header">
                    <h3>Our CLients</h3>
                </div>
                <div className="row no-gutters clients-wrap clearfix wow fadeInUp">
                    <div className="col-lg-6 col-md-4 col-xs-6 p-2 " data-aos="zoom-in">
                        <div className="text-center text-white font-weight-light">
                            <h6>Miss South Africa Plus World 2021</h6>
                        </div>
                        <div className="client-logo"> <img src={Apiwe} className="img-fluid" alt="" /> </div>
                    </div>
                    <div className="col-lg-6 col-md-4 col-xs-6 p-2" data-aos="zoom-in">
                        <div className="text-center text-white font-weight-light">
                            <h6>Mr and Miss Able 2021</h6>
                        </div>
                        <div className="client-logo">
                            <img src={MrAndMsAble} className="img-fluid" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Portfolio